import React from 'react'
import { SocialWebSourcesWidget as SocialWebSourcesWidgetSchema } from 'schemas/SocialWebSourcesWidgetSchema'
import { Widget } from 'features/types'

import { useDashboardWidgetSetting } from '../../../hooks/useDashboardState'
import DisplayOption from '../../../enums/DisplayOption'
import SourceDonut from './SourceDonut'
import AreaDisplay from './AreaDisplay'

const SocialWebSourcesWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebSourcesWidgetSchema>(widgetId)
  switch (widgetSetting.displayOption) {
    case DisplayOption.AREA:
      return <AreaDisplay widgetId={widgetId} />
    case DisplayOption.PIE:
      return <SourceDonut widgetId={widgetId} />
    default:
      throw new Error(`Unsupported display option: ${widgetSetting.displayOption}`)
  }
}

export default SocialWebSourcesWidget
